<template lang="pug">

  div

    //-
      -
      - BUSCA
      -
      -

    //- v-dialog(v-model="visible" max-width="500px" :persistent="searching")
    v-dialog(v-model="visible" max-width="560px" :persistent="searching")

      .dialogHeader

        .dialogHeaderTitle
          | Encontre uma unidade de atendimento

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close")

      .dialogBody

        .dialogBodyContent

          //-
            -
            -
            - BUSCA
            -
            -
            -

          .searchInput

            input.searchField(v-model="searchTerm" type="text" :disabled="searching || loadingPage" maxlength="64" placeholder="Digite o nome")

            .searchLoading(v-if="isValidSearchTerm && (searching /* || loadingPage */)")
              v-progress-circular(indeterminate color="red" size="25")

            sos-button(v-else :disabled="searching || loadingPage || !isValidSearchTerm" @buttonClick="search()" color="purple" size="small" buttonIcon="mdi-magnify" buttonIconSize="20")

          //-
            -
            -
            - RESULTADO DA BUSCA
            -
            -
            -

          template(v-if="!searching")

            template(v-if="foundGroupStatus === 'FOUND'")

              //-
                - RESULTADOS
                -

              .groupList.mt-7(:class="{ 'groupList--loading': loadingPage }")

                .groupListLoader(v-if="loadingPage")

                  .dialogLoaderCircle

                .groupListBody

                  .foundGroupItem(v-for="(group, groupIndex) in foundGroups" @click="onClickGroup(group)" :key="group.groupId || `group_bug_${groupIndex}`" :class="{ 'groupItem--disabled': !!group.groupId === false, 'groupItem--last': groupIndex === foundGroups.length - 1 }")

                    .groupTitle
                      | {{ group.groupName.length > 0 ? group.groupName : (group.groupId || 'Erro') }}

              sos-navigation(v-if="pagesCount > 1" :disabled="loadingPage" :pagesCount="pagesCount" :pageNumber="pageNumber" @onClickPrevPageButton="onClickPrevPageButton" @onClickNextPageButton="onClickNextPageButton" @onClickPageButton="onClickPageButton")

              .foundUserTitle
                | {{ foundResults }} ocorrências

            //-
              - GRUPO NÃO ENCONTRADO
              -

            template(v-else-if="foundGroupStatus === 'NOT_FOUND'")

              .foundUserTitle
                | Nenhum resultado

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

</template>

<script>

  import { apiGetUserId } from '@/services/firebase'
  import { apiSearchUnitsByName } from '@/services/consultations'

  import SosButton from '@/components/SosButton'
  import SosNavigation from '@/components/SosNavigation'

  import ConfirmDialog from '@/modals/ConfirmDialog'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  //
  //
  //

  const pageSize = 10

  export default {
    name: 'DialogFindGroup',

    components: {
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
      'sos-navigation': SosNavigation,
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        visible: false,

        searching: false,
        loadingPage: false,

        searchTerm: '',

        foundGroupStatus: 'WAITING',
        foundGroups: [],

        foundResults: 0,

        pageNumber: 0,
        pagesCount: 0,

        groupID: '',
      }
    },

    computed: {
      isValidSearchTerm: function () {
        return String(this.searchTerm).trim().length >= 3
      },

      searchTermLowercase: function () {
        return String(this.searchTerm).trim().toLowerCase()
      },
    },

    watch: {
      visible: {
        // the callback will be called immediately after the start of the observation
        handler (currentVisible, previousVisible) {
          if (currentVisible === false) {
            this.clear()
          }
        },
      },
    },

    /* mounted () {
    },

    beforeDestroy () {
    }, */

    methods: {
      /**
       *
       * ABRE O "DialogFindGroup" (UMA ESPÉCIE DE "OnMounted")
       *
       */

      open (groupID = '')
      {
        this.visible = true

        this.clear()

        const routeGroupID = this.$route.params.groupID || ''
        this.groupID = groupID || routeGroupID
      },

      close () {
        if (this.searching || this.loadingPage) return false

        this.visible = false
      },

      /**
       *
       * LIMPEZA
       *
       */

      clear () {
        this.searching = false
        this.loadingPage = false

        this.searchTerm = ''

        this.foundGroupStatus = 'WAITING'
        this.foundGroups = []

        this.foundResults = 0

        this.pageNumber = 0
        this.pagesCount = 0

        this.groupID = ''
      },

      //
      //
      //

      onClickGroup (group)
      {
        if (this.loadingPage || !!group.groupId === false) return false

        this.$emit('return', group)

        this.clear()
        this.visible = false
      },

      //
      //
      //

      async onClickPrevPageButton (pageNumber)
      {
        await this.loadPage(pageNumber)
      },

      async onClickNextPageButton (pageNumber)
      {
        await this.loadPage(pageNumber)
      },

      async onClickPageButton (pageNumber)
      {
        await this.loadPage(pageNumber)
      },

      //
      //
      //

      async search ()
      {
        if (!this.isValidSearchTerm)
        {
          this.foundGroupStatus = 'WAITING'
          this.foundGroups = []

          return false
        }

        await this.loadPage(false)
      },

      //
      //
      //

      async loadPage (pageNumber = false)
      {
        if (pageNumber === false) {
          this.searching = true
        } else {
          this.loadingPage = true
        }

        const terms = window.btoa(unescape(encodeURIComponent(this.searchTermLowercase)))
        const offset = pageNumber <= 0 || pageNumber === false ? 0 : pageNumber * pageSize

        const request = await apiSearchUnitsByName({ viewerID: apiGetUserId(), terms, offset, groupID: this.groupID })

        //
        // HOUVE ALGUM ERRO AO BUSCAR GRUPO
        //

        if (request.httpCode !== 200)
        {
          this.foundGroupStatus = 'ERROR'
          this.foundGroups = []

          //
          // SINALIZA FIM DO CARREGAMENTO/PROCESSAMENTO PARA A TELA
          //

          if (pageNumber === false) {
            this.searching = false
          } else {
            this.loadingPage = false
          }

          return this.showMessage(request.title, request.message)
        }

        //
        // Success
        //

        const maxResults = request?.data?.total_results || 0
        const paginatedItems = request?.data?.paginated_items || []

        this.foundGroupStatus = paginatedItems.length > 0 ? 'FOUND' : 'NOT_FOUND'

        this.foundGroups = paginatedItems.length > 0 ? paginatedItems.map((group, _) => ({
          groupId: !!group.id === true && group.id !== 'null' ? String(group.id).trim() : '',
          groupName: !!group.name === true && group.name !== 'null' ? String(group.name).trim() : '',
        })) : []

        this.foundResults = maxResults

        //
        // SET PAGE / NAVIGATOR
        //

        this.pagesCount = Math.ceil(maxResults / pageSize)
        this.pageNumber = pageNumber || 0

        //
        // SINALIZA FIM DO CARREGAMENTO/PROCESSAMENTO PARA A TELA
        //

        if (pageNumber === false) {
          this.searching = false
        } else {
          this.loadingPage = false
        }
      },

      /**
       *
       * CONFIRM DIALOG OUTPUT/RESPONSE
       *
       */

      cdAction (cdResponse)
      {
        // if (cdResponse === false) return false
      },
    },
  }

</script>

<style scoped lang="scss">

  .groupListLoader {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    width: 28px;
    height: 28px;
    margin: auto;
  }

  .groupList {
    position: relative;

    max-height: 181px;
    overflow: auto;

    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.15);

    &--loading
    {
      overflow: hidden;

      .groupListBody {
        opacity: 0.3;
      }
    }
  }

  .foundGroupItem {
    cursor: pointer;

    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);

    &--last {
      border-bottom: 0;
    }

    &--disabled {
      cursor: not-allowed;

      opacity: 0.5;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }

  .groupTitle {
    user-select: none;

    display: inline-block;
    vertical-align: middle;
    width: 100%;
    padding-left: 12px;
    padding-right: 6px;

    color: #555555;
    font-size: 14px;
    font-weight: 500;
    line-height: 35px;
    // line-height: 1.5;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  //
  //
  //

  .foundUserTitle {
    margin-top: 12px;

    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    text-align: right;
  }

  .searchFieldIcon {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0 !important;
    left: 12px;
  }

  .searchField {
    width: 100%;
    // max-width: 320px;
    height: 100%;
    background-color: #ffffff;
    padding: 0 56px 0 12px;
    // padding: 0 56px 0 40px;
    // padding: 0 20px 0 40px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    outline: 0;
    // box-shadow: 1px 2px 2px -1px rgba(0, 0, 0, 0.25);
    font-size: 15px;

    &:disabled {
      // background-color: #CCCCCC;
      opacity: 0.5;
    }
  }

  .searchInput {
    position: relative;
    display: block;
    width: 100%;
    // max-width: 320px;
    height: 40px;

    .sosButton {
      position: absolute;
      top: 6px;
      right: 6px;
    }
  }

  .searchLoading {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 25px;
    height: 25px;
  }

</style>
